/* eslint-disable react/jsx-no-target-blank */
import {useIntl} from 'react-intl'
import {AsideMenuItemWithSubMain} from './AsideMenuItemWithSubMain'
import {AsideMenuItem} from './AsideMenuItem'
import useLocalStorageFetch from '../../../../hooks/localStorageFetch'
import {useSelector} from 'react-redux'
import {checkPermission} from '../../../../app/App'

type PROPS = {
  isMinified: boolean
}

export function AsideMenuMain({isMinified}: PROPS) {
  const intl = useIntl()
  const dataUser: any = useSelector((state) => state)
  const {role} = useLocalStorageFetch()
  return (
    <>
      <AsideMenuItem
        to={'/dashboard'}
        title='Dashboard'
        icon='/media/ePulse/icons/aside/dashboard.svg'
        heading='Home'
        className='py-3'
        isMinified={isMinified}
      ></AsideMenuItem>
      {dataUser?.auth?.role === 'Doctor' && (
        <>
          {(checkPermission('getClinicRxTemplateList') ||
            checkPermission('getPaginationRxPrescriptionTemplateList') ||
            checkPermission('getAppointmentPaginationList') ||
            checkPermission('getDoctorCustomMedicineList') ||
            checkPermission('getClinicVaccineList') ||
            checkPermission('getBusinessConsumerComplainList')) && (
            <AsideMenuItemWithSubMain
              to='/rxmodule'
              title='Create Rx'
              icon='/media/ePulse/icons/aside/prescription.svg'
              heading='RX'
              isMinified={isMinified}
            >
              {checkPermission('getClinicRxTemplateList') && (
                <AsideMenuItem
                  to={`/${role}/rx_template`}
                  title='Template'
                  isMinified={isMinified}
                  isSubItem={true}
                />
              )}
              {checkPermission('getPaginationRxPrescriptionTemplateList') && (
                <AsideMenuItem
                  to={`/${role}/prescription-codes`}
                  title='Prescription Codes'
                  isMinified={isMinified}
                  isSubItem={true}
                />
              )}
              {checkPermission('getAppointmentPaginationList') && (
                <AsideMenuItem
                  to={`/${role}/prescription-history`}
                  title='Prescription History'
                  isMinified={isMinified}
                  isSubItem={true}
                />
              )}
              {checkPermission('getDoctorCustomMedicineList') && (
                <AsideMenuItem
                  to={`/${role}/custom-medicines`}
                  title='Custom Medicines'
                  isMinified={isMinified}
                  isSubItem={true}
                />
              )}
              {checkPermission('getClinicVaccineList') && (
                <AsideMenuItem
                  to={`/${role}/custom-vaccinations`}
                  title='Custom Vaccinations'
                  isMinified={isMinified}
                  isSubItem={true}
                />
              )}

              {checkPermission('getBusinessConsumerComplainList') && (
                <AsideMenuItem
                  to={`/${role}/complaints`}
                  title='Custom Complaints'
                  isMinified={isMinified}
                  isSubItem={true}
                />
              )}
            </AsideMenuItemWithSubMain>
          )}

          {(checkPermission('getDoctorPrescription') ||
            checkPermission('getBusinessStaffList') ||
            checkPermission('getBusinessAppSetting') ||
            checkPermission('getBusinessRolesList')) && (
            <AsideMenuItemWithSubMain
              to='/settingssection'
              title='Setting'
              icon='/media/ePulse/icons/aside/setting.svg'
              heading='Setting'
              isMinified={isMinified}
            >
              {checkPermission('getDoctorPrescription') && (
                <AsideMenuItem
                  to={`/${role}/application_setting/prescription_designer`}
                  title='Prescription Designer'
                  isMinified={isMinified}
                  isSubItem={true}
                />
              )}
              {checkPermission('getBusinessStaffList') && (
                <AsideMenuItem
                  to={`/${role}/staff-management`}
                  title='Staff Management'
                  isMinified={isMinified}
                  isSubItem={true}
                ></AsideMenuItem>
              )}
              {checkPermission('getBusinessAppSetting') && (
                <AsideMenuItem
                  to={`/${role}/business-app-setting/login-hours`}
                  title='Business Application Setting'
                  isMinified={isMinified}
                  isSubItem={true}
                />
              )}

              {checkPermission('getBusinessRolesList') && (
                <AsideMenuItem
                  to={`/${role}/roles-permission`}
                  title='Roles & Permissions'
                  isMinified={isMinified}
                  isSubItem={true}
                />
              )}
              <AsideMenuItem
                to={`/${role}/notification/template`}
                title='Notification'
                isMinified={isMinified}
                isSubItem={true}
              />
            </AsideMenuItemWithSubMain>
          )}
          {checkPermission('getBusinessPatientPaginationList') && (
            <AsideMenuItem
              to={`/${role}/patients`}
              title='Patients'
              icon='/media/ePulse/icons/aside/vendor.png'
              heading='Patients'
              className='py-3'
              isMinified={isMinified}
            ></AsideMenuItem>
          )}
          {checkPermission('getRefferedUserList') && (
            <AsideMenuItemWithSubMain
              to={`/${role}/refer`}
              title='Doctor'
              icon='/media/ePulse/icons/aside/refer.png'
              heading='Refer'
              isMinified={isMinified}
            >
              <AsideMenuItem
                to={`/${role}/refer`}
                title='Refer'
                isMinified={isMinified}
                isSubItem={true}
              ></AsideMenuItem>
            </AsideMenuItemWithSubMain>
          )}
          {((checkPermission('getTotalTransactionGraphHistory') &&
            checkPermission('getTotalTransactionHistory')) ||
            checkPermission('getOrderPaymentHistoryListForClinic') ||
            checkPermission('getBusinessAdminSettlementList')) && (
            <AsideMenuItemWithSubMain
              to='/summary'
              title='Transactions'
              fontIcon='bi-sticky'
              icon='/media/ePulse/icons/aside/inventory.png'
              heading='Transactions'
              isMinified={isMinified}
            >
              {checkPermission('getTotalTransactionGraphHistory') &&
                checkPermission('getTotalTransactionHistory') && (
                  <AsideMenuItem
                    to={`/${role}/summary`}
                    title='Summary'
                    isMinified={isMinified}
                    isSubItem={true}
                  />
                )}
              {checkPermission('getOrderPaymentHistoryListForClinic') && (
                <AsideMenuItem
                  to={`/${role}/payments`}
                  title='Payments'
                  isMinified={isMinified}
                  isSubItem={true}
                />
              )}
              {checkPermission('getBusinessAdminRefundList') && (
                <AsideMenuItem
                  to={`/${role}/refunds`}
                  title='Refunds'
                  isMinified={isMinified}
                  isSubItem={true}
                />
              )}
              {checkPermission('getBusinessAdminSettlementList') && (
                <AsideMenuItem
                  to={`/${role}/settlements`}
                  title='Settlements'
                  isMinified={isMinified}
                  isSubItem={true}
                />
              )}

              {/* {checkPermission('getBusinessAdminSettlementList') && (
                <AsideMenuItem
                  to={`/${role}/account-statement`}
                  title='Account Statement'
                  isMinified={isMinified}
                />
              )} */}

              {checkPermission('getBusinessAdminSettlementList') && (
                <AsideMenuItem
                  to={`/${role}/transaction-statement`}
                  title='Transaction Statement'
                  isMinified={isMinified}
                  isSubItem={true}
                />
              )}
            </AsideMenuItemWithSubMain>
          )}
          {checkPermission('getMedGeminiUserConsumerConsumedToken') && (
            <AsideMenuItem
              to={`/${role}/ai-report-analysis`}
              title='AI'
              heading='AI'
              className='py-3'
              icon='/media/ePulse/icons/aside/AI_logo.png'
              isMinified={isMinified}
            ></AsideMenuItem>
          )}
          {/* <AsideMenuItem
            to={`/${role}/ai-report-analysis`}
            title='AI'
            heading='AI'
            className='py-3'
          ></AsideMenuItem> */}
        </>
      )}

      {dataUser?.auth?.role === 'ScanCenter' && (
        <>
          <AsideMenuItemWithSubMain
            to='/settingssection'
            title='Settings'
            icon='/media/ePulse/icons/aside/setting.svg'
            heading='Settings'
            isMinified={isMinified}
          >
            {checkPermission('updateProductSlots') && (
              <AsideMenuItem
                to={`/${role}/booking_slot_scan`}
                title='Booking Slot'
                isMinified={isMinified}
                isSubItem={true}
              />
            )}
            {checkPermission('getScanAppointmentCancellationSettings') && (
              <AsideMenuItem
                to={`/${role}/cancellation-setting`}
                title='Cancellation Settings'
                isMinified={isMinified}
                isSubItem={true}
              />
            )}
              {checkPermission('getBusinessStaffListV2') && (
              <AsideMenuItem
                to={`/${role}/staff-management`}
                title='Staff Management'
                isMinified={isMinified}
                isSubItem={true}
              />
            )}
          
            {checkPermission('getBusinessAppSetting') && (
              <AsideMenuItem
                to={`/${role}/business-app-setting/login-hours`}
                title='Business Application Setting'
                isMinified={isMinified}
                isSubItem={true}
              />
            )}
            {checkPermission('getBusinessRolesList') && (
              <AsideMenuItem
                to={`/${role}/roles-permission`}
                title='Roles & Permissions'
                isMinified={isMinified}
                isSubItem={true}
              />
            )}

            <AsideMenuItem
              to={`/${role}/notification/template`}
              title='Notification'
              isMinified={isMinified}
              isSubItem={true}
            />
          </AsideMenuItemWithSubMain>
          {checkPermission('getBusinessPatientPaginationList') && (
            <AsideMenuItem
              to={`/${role}/patientupload`}
              title='inventory'
              icon='/media/ePulse/icons/aside/patient.png'
              heading='Patients'
              className='py-3'
              isMinified={isMinified}
            ></AsideMenuItem>
          )}
          <AsideMenuItemWithSubMain
            to='/summary'
            title='Summary'
            fontIcon='bi-sticky'
            icon='/media/ePulse/icons/aside/inventory.png'
            heading='Summary'
            isMinified={isMinified}
          >
            {checkPermission('getTotalTransactionGraphHistory') &&
              checkPermission('getTotalTransactionHistory') && (
                <AsideMenuItem
                  to={`/${role}/summary`}
                  title='Summary'
                  isMinified={isMinified}
                  isSubItem={true}
                />
              )}
            {checkPermission('getOrderPaymentHistoryListForBusinessAdmin') && (
              <AsideMenuItem
                to={`/${role}/payments`}
                title='Payments'
                isMinified={isMinified}
                isSubItem={true}
              />
            )}
            {checkPermission('getBusinessAdminSettlementList') && (
              <AsideMenuItem
                to={`/${role}/settlements`}
                title='Settlements'
                isMinified={isMinified}
                isSubItem={true}
              />
            )}
            {checkPermission('getBusinessAdminSettlementList') && (
              <AsideMenuItem
                to={`/${role}/transaction-statement`}
                title='Transaction Statement'
                isMinified={isMinified}
                isSubItem={true}
              />
            )}
          </AsideMenuItemWithSubMain>
          <AsideMenuItemWithSubMain
            to='/product-offering'
            title='Products'
            icon='/media/ePulse/icons/aside/setting.svg'
            heading='Products'
            isMinified={isMinified}
          >
            {
              // checkPermission('updateProductSlots')
              //  &&
              <AsideMenuItem
                to={`/${role}/product-offering`}
                title='Product Offering'
                isSubItem={true}
              />
            }

            {
              // checkPermission('getScanAppointmentCancellationSettings')
              // &&
              <AsideMenuItem to={`/${role}/product`} title='Product' isSubItem={true} />
            }
            {
              // checkPermission('getScanAppointmentCancellationSettings')
              // &&
              <AsideMenuItem to={`/${role}/labs`} title='Labs' isSubItem={true} />
            }
          </AsideMenuItemWithSubMain>
          <AsideMenuItem
            to={`/${role}/report`}
            title='Report'
            className='py-3'
            icon='/media/ePulse/icons/aside/reports.svg'
            heading='Report'
            isMinified={isMinified}
          ></AsideMenuItem>
          <AsideMenuItem
            to={`/${role}/create-appointment`}
            title='Create Appointment'
            className='py-3'
            icon='/media/ePulse/icons/aside/add_circle.svg'
            heading='Create Appointment'
            isMinified={isMinified}
          ></AsideMenuItem>
        </>
      )}

      {dataUser?.auth?.role === 'Pharmacy' && (
        <>
          {checkPermission('getInventoryList') && (
            <AsideMenuItemWithSubMain
              to={`/${role}/inventory`}
              title='inventory'
              fontIcon='bi-sticky'
              icon='/media/ePulse/icons/aside/inventory.png'
              heading='Inventory'
              isMinified={isMinified}
            >
              {checkPermission('getInventoryList') && (
                <AsideMenuItem
                  to={`/${role}/inventory/active`}
                  title='Active Inventory'
                  isMinified={isMinified}
                  isSubItem={true}
                />
              )}
              {checkPermission('getInventoryList') && (
                <AsideMenuItem
                  to={`/${role}/inventory/in-active`}
                  title='InActive Inventory'
                  isMinified={isMinified}
                  isSubItem={true}
                />
              )}
            </AsideMenuItemWithSubMain>
          )}
           <AsideMenuItemWithSubMain
            to='/settingssection'
            title='Setting'
            icon='/media/ePulse/icons/aside/setting.svg'
            heading='Setting'
            isMinified={isMinified}
          >
            {checkPermission('getPaginationRxPrescriptionTemplateList') && (
              <AsideMenuItem
                to={`/${role}/prescription-codes`}
                title='Prescription Code'
                isMinified={isMinified}
                isSubItem={true}
              />
            )}

            {checkPermission('getBusinessAppSetting') && (
              <AsideMenuItem
                to={`/${role}/business-app-setting/login-hours`}
                title='Business Application Setting'
                isMinified={isMinified}
                isSubItem={true}
              />
            )}
                {checkPermission('getBusinessRolesList') && (
              <AsideMenuItem
                to={`/${role}/billing-template`}
                title='Billing Template'
                isMinified={isMinified}
                isSubItem={true}
              />
            )}
               {checkPermission('getPaginationRxPrescriptionTemplateList') && (
              <AsideMenuItem
                to={`/${role}/settingssection/discount-settings`}
                title='Discount Settings'
                isMinified={isMinified}
                isSubItem={true}
              />
            )}

            {checkPermission('getBusinessRolesList') && (
              <AsideMenuItem
                to={`/${role}/roles-permission`}
                title='Roles & Permissions'
                isMinified={isMinified}
                isSubItem={true}
              />
            )}
             {checkPermission('getBusinessStaffListV2') && (
              <AsideMenuItem
                to={`/${role}/staff-management`}
                title='Staff Management'
                isMinified={isMinified}
                isSubItem={true}
              />
            )}

            {checkPermission('getNotificationTemplateForBusiness') && (
              <AsideMenuItem
                to={`/${role}/notification/template`}
                title='Notification'
                isMinified={isMinified}
                isSubItem={true}
              />
            )}
          </AsideMenuItemWithSubMain>
          {checkPermission('getVendorList') && (
            <AsideMenuItem
              to={`/${role}/vendor`}
              title='vendor'
              icon='/media/ePulse/icons/aside/vendor.png'
              heading='Vendor'
              className='py-3'
              isMinified={isMinified}
            ></AsideMenuItem>
          )}
          {checkPermission('getBusinessPatientPaginationList') && (
            <AsideMenuItem
              to={`/${role}/patient`}
              title='patients'
              icon='/media/ePulse/icons/aside/patient.png'
              heading='Patients'
              className='py-3'
              isMinified={isMinified}
            ></AsideMenuItem>
          )}
          
          
          <AsideMenuItemWithSubMain
            to='/orders'
            title='Order History'
            fontIcon='bi-sticky'
            icon='/media/ePulse/icons/aside/inventory.png'
            heading='Order History'
            isMinified={isMinified}
          >
         {checkPermission('getSalesOrderList') && (
            <AsideMenuItem
              to={`/${role}/orders/sales-order-history`}
              title='Sale Order History'
              isMinified={isMinified}
              isSubItem={true}
            />
         )}
        { checkPermission('getPurchaseOrderList') && (
                <AsideMenuItem
              to={`/${role}/orders/purchase-order-history`}
              title='Purchase Order History'
              isMinified={isMinified}
              isSubItem={true}
            />
          )}
          </AsideMenuItemWithSubMain>

          {checkPermission('createSaleOrder') && (
            <AsideMenuItemWithSubMain
              to='/sale-order'
              title='Sale Order'
              //  icon='/media/ePulse/icons/aside/vendor.png'
              // icon='/media/ePulse/icons/aside/SaleOrder.png'
              icon='/media/ePulse/icons/aside/saleOrderIcon.png'
              heading='Sale Order'
              isMinified={isMinified}
            >
              {checkPermission('createSaleOrder') && (
                <AsideMenuItem
                  to={`/${role}/sale-order`}
                  title='Sale Order'
                  isMinified={isMinified}
                  isSubItem={true}
                  // heading='Setting'
                />
              )}
              {checkPermission('createSaleOrder') && (
                <AsideMenuItem
                  to={`/${role}/doctor-sale-order`}
                  title="Doctor's Order"
                  isMinified={isMinified}
                  isSubItem={true}
                  // heading='Setting'
                />
              )}
            </AsideMenuItemWithSubMain>
          )}
         
        </>
      )}
    </>
  )
}
